export enum VideoSrcType {
  Brightcove = 'BrightcoveVideo',
  YouTube = 'YouTubeVideo',
}

export const getVideoUrl = (mediaUrl: string) =>
  mediaUrl.includes('https://www.youtube') ? getYoutubeUrl(mediaUrl) : mediaUrl;

export const getYoutubeUrl = (mediaUrl: string) =>
  mediaUrl.includes('https://www.youtube.com/embed/')
    ? mediaUrl
    : constructUrl(mediaUrl);

export const constructUrl = (mediaUrl: string) => {
  const videoId = getVideoID(mediaUrl);
  return `https://www.youtube.com/embed/${videoId}`;
};

export const getVideoID = (mediaUrl: string) => {
  const regExp =
    /^.*(youtu\.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
  const matchId = mediaUrl.match(regExp);
  let videoId: string;
  if (matchId && matchId[2].length === 11) {
    videoId = matchId[2];
  } else {
    videoId = '';
  }
  return videoId;
};

export const getVideoType = (url: string) => {
  /**
     TODO: can replace if conditional checks with ENUMS
     so that if we add new type it will reduce the branching
     */
  if (url.includes('brightcove') || url.includes('bcove')) {
    return VideoSrcType.Brightcove;
  } else if (url.includes('youtube')) {
    return VideoSrcType.YouTube;
  }
  return undefined;
};
